import axios from "axios";
import { useContext } from "react";
import useSWR from "swr";
import { AuthContext } from "../../../context/AuthContext";
import { ADMIN_API_URL } from "../../../utils/env";

// Response for specific epoch (with epoch param)
export interface ITradingRewardsV2AccountData {
  account: string;
  epoch: number;
  trading_volume: number;
  percentage_share: number;
  reward_amount: string;
}

export interface ITradingRewardsV2EpochResponse {
  epoch: number;
  data: ITradingRewardsV2AccountData[];
}

// Hook to fetch specific epoch data
export const useTradingRewardsV2Epoch = (epoch: number | undefined) => {
  const { tokenId, queryConfig } = useContext(AuthContext);
  const endpoint = ADMIN_API_URL("trading-rewards-v2");

  const { data, error, isLoading, mutate } =
    useSWR<ITradingRewardsV2EpochResponse>(
      tokenId && epoch ? [endpoint, tokenId, epoch] : null,
      async () => {
        const response = await axios.get<ITradingRewardsV2EpochResponse>(
          endpoint,
          {
            ...queryConfig(),
            params: { epoch },
          }
        );
        return response.data;
      }
    );

  return {
    data: data?.data,
    epoch: data?.epoch,
    error,
    isLoading,
    mutate,
  };
};
